const perfisMa = {
  SISTEMA: 'SISTEMA',
  AGENTE_ADMINISTRATIVO_PROTOCOLO: 'AGENTE_ADMINISTRATIVO_PROTOCOLO',
  DIRETOR_DRF: 'DIRETOR_DRF',
  ASSESSOR_DRF: 'ASSESSOR_DRF',
  COORDENADOR_CAF: 'COORDENADOR_CAF',
  ASSESSOR_TECNICO_CAF: 'ASSESSOR_TECNICO_CAF',
  CHEFE_SETOR_DF1: 'CHEFE_SETOR_DF1',
  TECNICO_DF1: 'TECNICO_DF1',
  CHEFE_SETOR_DF3: 'CHEFE_SETOR_DF3',
  TECNICO_DF3: 'TECNICO_DF3',
  CHEFE_SETOR_COMISSAO_ILHA: 'CHEFE_SETOR_COMISSAO_ILHA',
  TECNICO_COMISSAO_ILHA: 'TECNICO_COMISSAO_ILHA',
  PROCURADOR_JURIDICO: 'PROCURADOR_JURIDICO',
  ADVOGADO_JURIDICO: 'ADVOGADO_JURIDICO',
  CHEFE_SETOR_DATGL: 'CHEFE_SETOR_DATGL',
  TECNICO_DATGL: 'TECNICO_DATGL',
  PRESIDENTE_PRESIDENCIA: 'PRESIDENTE_PRESIDENCIA',
  ASSESSOR_PRESIDENCIA: 'ASSESSOR_PRESIDENCIA',
  CHEFE_GABINETE_PRESIDENCIA: 'CHEFE_GABINETE_PRESIDENCIA',
  CHEFE_SETOR_CAS: 'CHEFE_SETOR_CAS',
  TECNICO_CAS: 'TECNICO_CAS',
  COORDENADOR_CTT: 'COORDENADOR_CTT',
  ASSESSOR_TECNICO_CTT: 'ASSESSOR_TECNICO_CTT',
  DIRETOR_DADR: 'DIRETOR_DADR',
  ASSESSOR_DADR: 'ASSESSOR_DADR',
  COORDENADOR_CEP: 'COORDENADOR_CEP',
  ASSESSOR_TECNICO_CEP: 'ASSESSOR_TECNICO_CEP',
  DIRETOR_DAF: 'DIRETOR_DAF',
  ASSESSOR_DAF: 'ASSESSOR_DAF',
  COORDENADOR_CADR: 'COORDENADOR_CADR',
  ASSESSOR_TECNICO_CADR: 'ASSESSOR_TECNICO_CADR',
  DIRETOR_DUF: 'DIRETOR_DUF',
  ASSESSOR_DUF: 'ASSESSOR_DUF',
  CHEFE_SETOR_DEO: 'CHEFE_SETOR_DEO',
  ASSESSOR_DEO: 'ASSESSOR_DEO',
  DIRETOR_DUA: 'DIRETOR_DUA',
  ASSESSOR_DUA: 'ASSESSOR_DUA',
  CHEFE_SETOR_DGRH: 'CHEFE_SETOR_DGRH',
  ASSESSOR_DGRH: 'ASSESSOR_DGRH',
  CHEFE_SETOR_DMP: 'CHEFE_SETOR_DMP',
  ASSESSOR_DMP: 'ASSESSOR_DMP',
  EXTERNO: 'EXTERNO',
  PRODUTIVIDADE: 'PRODUTIVIDADE',
  AGENDAMENTO: 'AGENDAMENTO',
  GESTOR_DE_DEMANDAS: 'GESTOR_DE_DEMANDAS',
  GOVERNADOR: 'GOVERNADOR',
  CHEFE_SETOR_GABINETE: 'CHEFE_SETOR_GABINETE',
  MANUTENTOR: 'MANUTENTOR',
  ADMINISTRADOR_PROCESSO: 'ADMINISTRADOR_PROCESSO',
  COMISSAO_GESTAO_SICARF: 'COMISSAO_GESTAO_SICARF',
  GESTOR_SICARF: 'GESTOR_SICARF',
  ANALISTA_CTRU: 'ANALISTA_CTRU'
}

export default perfisMa



// WEBPACK FOOTER //
// ./src/utils/ma/perfis.js